import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReAuth } from "@/store/api/baseQueryWithReAuth";

export interface InnerDocument {
  id: number;
  attachment: string;
  status: 0 | 1;
  address?: string;
  date?: string;
  responsible_party?: string;
  ein_number?: string;
  title?: string;
  number_title?: string;
  number_value?: string;
  ar_number?: string;
  year?: string;
  step?: string;
  filing_id?: string;
  start_date?: string;
  end_date?: string;
  form_status?: boolean;
}

export interface Document {
  dissolve?: InnerDocument[];
  rc?: InnerDocument[];
  stc?: InnerDocument[];
  tf?: InnerDocument[];
  additional_doc?: InnerDocument[];
  cof?: InnerDocument[];
  ein?: InnerDocument[];
  oa?: InnerDocument[];
  boi?: InnerDocument[];
  coi?: InnerDocument[];
  maaoa?: InnerDocument[];
  ramc?: InnerDocument[];
  utr?: InnerDocument[];

  uae_cof?: InnerDocument[];
  uae_ec?: InnerDocument[];
  uae_las?: InnerDocument[];
  uae_maaoa?: InnerDocument[];
  uae_sr?: InnerDocument[];
  uae_tl?: InnerDocument[];
  uae_ula?: InnerDocument[];

  bd_coi?: InnerDocument[];
  bd_f12?: InnerDocument[];
  bd_maaoa?: InnerDocument[];

  itin?: InnerDocument[];
  sales_tax_compliance?: InnerDocument[];
  trademark_filling?: InnerDocument[];
  annual_report?: InnerDocument[];
  federal_tax?: InnerDocument[];

  ac?: InnerDocument[];
  ftrf?: InnerDocument[];
}

export const documentApi = createApi({
  reducerPath: "documentApi",
  baseQuery: baseQueryWithReAuth,
  tagTypes: ["Document"],
  endpoints: (builder) => ({
    getDocument: builder.query<Document, number>({
      query: (companyId) => `/client-document/${companyId}/`,
      providesTags: ["Document"],
    }),
  }),
});

export const { useGetDocumentQuery } = documentApi;
